import * as React from 'react'
import { Helmet } from 'react-helmet'
import qs from 'qs'

// components
import CatalogLayout from '../../../../components/ui/CatalogLayout/CatalogLayout'
import StoreModal from '../../../../components/home/StoreModal/StoreModal'
import LeaveModal from '../../../../components/home/LeaveModal/LeaveModal'
import {
  StyledBanner,
  BannerContent,
  BannerDescription,
  RewardsCatalogTitle,
  RewardsCatalogDescription,
  Heading,
  FormContainer,
  InputContainer,
  StyledTextInput,
  StyledCatalogList,
  StyledShopDineListCard,
  sectionDescription,
} from './MainView.style'

// data
import filterString from '../../../../services/data/filterString'
import { EXPLORE_VIEW_ALL } from '../../../../services/data/errorNames.json'
import uppercaseFirst from '../../../../services/data/uppercaseFirst'

// analytics
import {
  setGAPageView,
  setGAEvent,
} from '../../../../services/analytics/google-analytics'

// controllers
import {
  doGetExploreStore,
  doGetAllExploreShops,
  doGetAllExploreDine,
  doGetAllExploreUnwind,
  doGetAllExploreOrderMerchants,
} from '../../../../controllers/Explore'

class MainView extends React.Component {
  constructor(props) {
    super(props)

    const { location } = props.history || {}

    const initialSearch = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    })

    this.state = {
      apiKey: '',
      exploreData: [],
      searchQuery: initialSearch.q || '',
      searched: [],
      selectedBrand: {},
      promoCode: '',
    }

    this.getListData()
  }

  componentDidMount() {
    const { location } = this.props

    this.displayModal()

    setGAPageView(location.pathname)
  }

  componentDidUpdate(prevProps) {
    const { match, location } = this.props
    const { viewType, viewId } = match.params
    const {
      viewType: prevViewType,
      viewId: prevViewId,
    } = prevProps.match.params

    if (viewType !== prevViewType || viewId !== prevViewId) {
      this.displayModal()
    }

    if (location.pathname !== prevProps.location.pathname) {
      setGAPageView(location.pathname)
    }
  }

  getListData = async () => {
    const {
      accessToken,
      preferenceIds,
      match,
      history,
      errorList,
      setError,
      removeError,
    } = this.props
    const { mallSlug, viewType } = match.params

    const pageLoadStart = Date.now()

    const search = qs.parse(history.location.search, {
      ignoreQueryPrefix: true,
    })

    const onSuccess = ({ data }) => {
      this.setState({
        exploreData: data,
        searched: search.q
          ? data.filter(({ name }) =>
              name.toLowerCase().includes(search.q.toLowerCase()),
            )
          : [],
      })
    }

    if (errorList.length) {
      removeError(EXPLORE_VIEW_ALL)
    }

    if (viewType === 'shop') {
      await doGetAllExploreShops({
        mallSlug,
        setError,
        onSuccess,
        preferenceIds,
      })
      setGAEvent(
        'page',
        'loading_duration',
        'shop_catalog',
        Date.now() - pageLoadStart,
      )
    } else if (viewType === 'dine') {
      await doGetAllExploreDine({
        mallSlug,
        setError,
        onSuccess,
        preferenceIds,
      })
      setGAEvent(
        'page',
        'loading_duration',
        'dine_catalog',
        Date.now() - pageLoadStart,
      )
    } else if (viewType === 'unwind') {
      await doGetAllExploreUnwind({
        mallSlug,
        setError,
        onSuccess,
        preferenceIds,
      })
      setGAEvent(
        'page',
        'loading_duration',
        'unwind_catalog',
        Date.now() - pageLoadStart,
      )
    } else if (viewType === 'order') {
      await doGetAllExploreOrderMerchants({
        mallSlug,
        accessToken,
        onSuccess,
        setError,
      })
      setGAEvent(
        'page',
        'loading_duration',
        'order_now_catalog',
        Date.now() - pageLoadStart,
      )
    }
  }

  displayModal = async () => {
    const { match, setMerchantModalData, setMerchantModalStatus } = this.props
    const { viewType, viewId } = match.params

    if (['shop', 'dine', 'unwind'].indexOf(viewType) >= 0 && viewId) {
      try {
        setMerchantModalStatus(1)

        const merchantModalData = await doGetExploreStore({ viewId })

        setMerchantModalData(merchantModalData)
        setMerchantModalStatus(0)
      } catch (e) {
        setMerchantModalStatus(4)
      }
    } else {
      setMerchantModalStatus(null)
      setGAEvent('page', 'page_visit', `${viewType}_catalog`)
    }
  }

  handleClose = () => {
    const { push, baseUrl, match, setMerchantModalStatus } = this.props

    const { mallSlug, viewType } = match.params

    if (push) {
      push(`${baseUrl}/${mallSlug}/view-all/${viewType}`)
      setMerchantModalStatus(null)
    }
  }

  onCatalogChange = catalog => {
    this.setState({
      merchants: [],
    })
    this.getRewardsMerchants(catalog.id)
  }

  onCatalogSearch = e => {
    const { exploreData } = this.state

    const searched = exploreData.filter(merchant => {
      const merchantName = merchant.title
        ? merchant.title.toLowerCase()
        : merchant.name.toLowerCase()
      const searchQuery = e.target.value.toLowerCase()

      return merchantName.includes(searchQuery)
    })

    this.setState({
      searchQuery: e.target.value,
      searched,
    })
  }

  handleShowLeaveModal = brand => {
    this.setState({
      showLeaveModal: true,
      selectedBrand: brand,
    })
  }

  handleCloseLeaveModal = () => {
    this.setState({
      showLeaveModal: false,
    })
    setTimeout(
      () =>
        this.setState({
          selectedBrand: {},
        }),
      10,
    )
  }

  handleRedirectToLogin = () => {
    const { push } = this.props
    push('/login')
  }

  render() {
    const {
      baseUrl,
      history,
      malls,
      showRewardModal,
      rewardModalData,
      errorList,
      showMerchantModal,
      merchantModalData,
      merchantModalStatus,
      ...theProps
    } = this.props

    const {
      match,
      // , accessToken
    } = this.props

    const { mallSlug, viewType } = match.params

    const {
      exploreData,
      searched,
      searchQuery: searchQueryState,
      showLeaveModal,
      selectedBrand,
      // promoCode,
    } = this.state

    const contentDescription = sectionDescription[viewType] || {}

    const Banner = () => (
      <StyledBanner>
        <BannerContent>
          <BannerDescription>
            <RewardsCatalogTitle>
              {contentDescription.title}
            </RewardsCatalogTitle>
            <RewardsCatalogDescription>
              {contentDescription.description}
            </RewardsCatalogDescription>
          </BannerDescription>
        </BannerContent>
      </StyledBanner>
    )

    return (
      <CatalogLayout banner={Banner} {...theProps}>
        <Heading>
          <FormContainer>
            <InputContainer>
              <StyledTextInput
                variant="search"
                whiteOut
                placeholder="What are you looking for?"
                onChange={this.onCatalogSearch}
                onKeyDown={this.onSearchKeyDown}
                value={searchQueryState}
              />
            </InputContainer>
          </FormContainer>
        </Heading>
        <StyledCatalogList
          dataSource={searched.length ? searched : exploreData}
          loadingComponent={() => (
            <StyledShopDineListCard
              loading
              error={errorList.find(error => error.name === EXPLORE_VIEW_ALL)}
              errorMessage={`Failed to load ${uppercaseFirst(viewType)}.`}
              onRetry={this.getListData}
            />
          )}
          renderItem={(item, index) => (
            <StyledShopDineListCard
              key={item.itemId || item.id}
              id={index}
              iconUrl={item.logoUrl}
              isOrder={viewType === 'order'}
              cardImageUrl={item.imageUrl || item.backgroundUrl}
              title={item.title || item.name}
              subtitle={item.description || item.subtitle}
              link={`${baseUrl}/${mallSlug}/view-all/${viewType}/${item.itemId ||
                item.id}`}
              onClick={() => {
                viewType === 'order' && this.handleShowLeaveModal(item)
                setGAEvent(
                  'item_clicks',
                  `view_${viewType}_catalog_item`,
                  item.title,
                )
              }}
            />
          )}
        />
        <StoreModal
          malls={malls}
          show={showMerchantModal}
          data={merchantModalData}
          loading={merchantModalStatus}
          onClose={this.handleClose}
        />
        {showRewardModal && rewardModalData && (
          <Helmet defaultTitle={rewardModalData.title}>
            <meta property="og:title" content={rewardModalData.title} />
            <meta
              property="og:description"
              content={filterString(rewardModalData.body)}
            />
            <meta property="og:image" content={rewardModalData.imageUrl} />
            <meta property="og:type" content="website" />
          </Helmet>
        )}
        <LeaveModal
          show={showLeaveModal}
          onClose={this.handleCloseLeaveModal}
          // onAltClose={!accessToken && this.handleRedirectToLogin}
          // altCloseTitle={!accessToken && 'Join Now'}
          to={
            selectedBrand.onlineShopUrl
              ? /https:\/\/[a-zA-Z0-9]+/.test(selectedBrand.onlineShopUrl)
                ? selectedBrand.onlineShopUrl
                : `https://${selectedBrand.onlineShopUrl}`
              : ''
          }
          onProceed={this.handleCloseLeaveModal}
          // isLoggedIn={accessToken}
          // promoCode={selectedBrand && selectedBrand.promoCode}
          explore
        />
      </CatalogLayout>
    )
  }
}

MainView.defaultProps = {
  // TODO: specify default props
}

MainView.propTypes = {
  // TODO: specify prop types
}

export default MainView
